<h2>Information</h2>
<mat-dialog-content>
  <ng-container *ngIf="data.supportsTrainingLoadAnalysis">
    <p>This tier supports Training Load analysis.</p>
  </ng-container>
  <ng-container *ngIf="!data.supportsTrainingLoadAnalysis">
    <p>
      This tier does NOT support Training Load analysis.
      <br />
      <br />
      Please contact us for assistance in supporting this feature for your plan.
    </p>
    <br />
    <app-feedback></app-feedback>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions fxLayout="row">
  <button mat-raised-button [matDialogClose] color="primary">Okay</button>
</mat-dialog-actions>
